import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61c40720"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-bar" }

import { ref } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TabBar',
  setup(__props) {

const currentTab = ref("/");
const tabs = [
  {
    link: "/",
    label: "首页",
  },
  {
    link: "/product",
    label: "产品介绍",
  },
  {
    link: "/platform",
    label: "数字化平台",
  },
  {
    link: "/customization",
    label: "定制化服务",
  },
  {
    link: "/contact",
    label: "联系我们",
  },
];
const handleTabClick = (tab: string) => {
  currentTab.value = tab;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
      return _createVNode(_component_router_link, {
        to: tab.link,
        key: tab.link,
        class: _normalizeClass(['tab-link', { active: currentTab.value === tab.link }]),
        onClick: ($event: any) => (handleTabClick(tab.link))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(tab.label), 1)
        ]),
        _: 2
      }, 1032, ["to", "class", "onClick"])
    }), 64))
  ]))
}
}

})